import script from "./surrender-council-switch.vue?vue&type=script&setup=true&lang=ts"
export * from "./surrender-council-switch.vue?vue&type=script&setup=true&lang=ts"

import "./surrender-council-switch.vue?vue&type=style&index=0&id=356ebf09&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-356ebf09"]])

export default __exports__